export default __webpack_public_path__ + "static/media/ram-assist.171766ce.png";